import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

interface SortableItemRenderProps {
  dragHandleProps: React.HTMLAttributes<HTMLElement>;
  isDragging: boolean;
}

interface SortableItemProps {
  id: string | number;
  disabled?: boolean;
  style?: React.CSSProperties;
  children: (props: SortableItemRenderProps) => React.ReactNode;
}

export default function SortableItem({
  id,
  disabled,
  style: extraStyle,
  children,
}: SortableItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0 : 1,
        position: "relative",
        zIndex: isDragging ? 1 : "auto",
        ...extraStyle,
      }}
    >
      {children({
        dragHandleProps: { ...attributes, ...listeners },
        isDragging,
      })}
    </div>
  );
}
